export class IPayerClass
{
    payerClassId:number;
    payerClassCode:string;
    payerClassName:string;
    isActive:boolean;
    sourceId:string;
}
